import cn from 'classnames'

export const Field = ({ children, className }) => (
  <div className={cn('mb-3 last:mb-0', className)}>{children}</div>
)
